﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import * as api from "~base/Services/API";

//-------------------------------------------------------------------------------------
// Http Contract
//-------------------------------------------------------------------------------------

const uri = (
    domainAccessKey: string,
    domainAccessCode: string,
    locale: string
): string => {
    // Ensure this call isn't cached
    const cacheKey = new Date().getTime();

    const uri = `api/sopnl/v1/selfservice/logininfo?domainAccessKey=${encodeURIComponent(domainAccessKey)}&domainAccessCode=${encodeURIComponent(domainAccessCode)}&locale=${encodeURIComponent(locale)}&cacheKey=${cacheKey}`;

    return uri;
};

const method = "GET";

//-------------------------------------------------------------------------------------
// Types
//-------------------------------------------------------------------------------------

export interface GetSelfServiceLoginInfoResponse {
    Tenant: SelfServiceLoginInfoTenant;
    CustomerName: string;
    AgreementLink: string;
    AgreementText: string;
    DomainUid?: string;
}

export interface SelfServiceLoginInfoTenant {
    TenantName: string;
}

interface GetSelfServiceLoginInfoProps extends api.ApiHookBaseProps<
    unknown,
    GetSelfServiceLoginInfoResponse,
    unknown
> {
    domainAccessKey: string;
    domainAccessCode: string;
    locale: string;
}

//-------------------------------------------------------------------------------------
// API Hook
//-------------------------------------------------------------------------------------

export function useGetSelfServiceLoginInfo(
    props: GetSelfServiceLoginInfoProps
): [boolean, () => Promise<unknown>] {
    const apiParams: api.ApiHookProps<
        unknown,
        GetSelfServiceLoginInfoResponse,
        unknown
    > = {
        ...props,
        uri: uri(props.domainAccessKey, props.domainAccessCode, props.locale),
        method: method,
    };

    const [loading, invoker] = api.useApi<
        unknown,
        GetSelfServiceLoginInfoResponse,
        unknown
    >(apiParams);
    return [loading, () => invoker(apiParams.uri, undefined)];
}
